import React, {useState} from "react";
import {BoxIsolatedContent, FlexColumnCentered, FormGoBack, IconContainer} from "../../../components/ui/Content";
import {ButtonPrimary} from "../../../components/ui/Button";

import {FormTitle, RecoveryEmailInfo} from "../../../components/Font";
import {GoBack, GreenCircleCheck} from "../../../icon/Icon";
import {useTranslation} from "react-i18next";
import {setRecoveryData, setRecoveryStep} from "../slice";
import {useAppDispatch, useAppSelector} from "../../../app/hooks";
import {RecoveryInputContainer, RegisterInputContainer} from "../../../components/ui/InputSearch";
import {LoaderContainer, LoaderEnum, MiniLoader} from "../../../ui/Loader/MiniLoader";
import {useTheme} from "styled-components";
import {useLocation, useNavigate} from "react-router-dom";
import {AccountSelectBlock, InputIconContainer, SelectedUserContent} from "../Steps/LoginForm/LoginFormAdmin/style";
import {IPerson} from "../../../interface/Auth/backend";
import {RecoveryStepEnum} from "../../../enum/auth";
interface IProps {
    setSelectedUserAuth?:(arg :string | null)=> void
}
export const RecoveryAccount = ({setSelectedUserAuth}:IProps) => {

    const {t} = useTranslation();
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const {search} = useLocation()
    const Theme = useTheme()
    const {isFetching, accounts} = useAppSelector(state => state.auth)
    const [selectedUser, setSelectedUser] = useState<IPerson | null>(null)

    return <FlexColumnCentered className={'box-isolated'}>
        <BoxIsolatedContent>
            <FlexColumnCentered style={{width: '100%'}}>
                <FormGoBack onClick={() => {
                    dispatch(setRecoveryData(null))
                    navigate(`/sign-in${search}`)
                }}>
                    <GoBack/>
                </FormGoBack>
                <FormTitle>{setSelectedUserAuth == null ? t('auth.passwordRecovery') : t('auth.logInAccount')}</FormTitle>
                <RecoveryEmailInfo style={{textAlign: 'center', width: '270px'}}>
                    {t('auth.checkRecoveryAccount')}
                </RecoveryEmailInfo>
            </FlexColumnCentered>
            <RegisterInputContainer>
                <RecoveryInputContainer>
                    { accounts.map((account) => <AccountSelectBlock key={account.ad_person_id}
                    onClick={() => selectedUser?.id === account.ad_person_id.toString() ? setSelectedUser(null) : setSelectedUser({
                        id: account.ad_person_id.toString(),
                        fio: account.fio,
                        email: account.email
                    })}
                >
                    <InputIconContainer style={{marginLeft: '10px'}}>
                        {selectedUser?.id === account.ad_person_id.toString() && <IconContainer>
                            <GreenCircleCheck/>
                        </IconContainer>}
                    </InputIconContainer>
                    <SelectedUserContent
                        style={{marginLeft: (selectedUser?.id === account.ad_person_id.toString()) ? '-20px' : '-50px'}}>
                        <div>
                            {account.fio}
                        </div>
                        <div>
                            {account.email}
                        </div>
                    </SelectedUserContent>

                </AccountSelectBlock>)}

                </RecoveryInputContainer>
            </RegisterInputContainer>
            {isFetching
                ? <ButtonPrimary style={{
                    width: '100%',
                    marginTop: '24px'
                }}>
                    <LoaderContainer>
                        <MiniLoader color={Theme.color.primaryBackground} size={LoaderEnum.small}/>
                    </LoaderContainer>
                </ButtonPrimary>
                : <ButtonPrimary
                    disabled={!selectedUser}
                    onClick={() => {
                        localStorage.setItem('selectedUser', selectedUser?.id || '')
                        if(setSelectedUserAuth){
                        setSelectedUserAuth(localStorage.getItem('selectedUser'))}
                        dispatch(setRecoveryStep(RecoveryStepEnum.CreateNewPassword))
                    }}
                    style={{
                        width: '100%',
                        marginTop: '24px'
                    }}>
                    {t('auth.continue')}
                </ButtonPrimary>}
        </BoxIsolatedContent>
    </FlexColumnCentered>
}
